import { useState, useEffect } from 'react';
import { getContentZoom, type ContentZoom } from './contentZoom';

export function useContentZoom(): ContentZoom {
  const [zoom, setZoom] = useState<ContentZoom>(getContentZoom);

  useEffect(() => {
    const handler = () => setZoom(getContentZoom());
    window.addEventListener('lex-content-zoom-change', handler);
    return () => window.removeEventListener('lex-content-zoom-change', handler);
  }, []);

  return zoom;
}
